import { useState } from 'react';

import agent from '../../../../api/agent';
import { Static } from '../../../../static';
import { EtichettaValore } from '../../../../models/etichetta-valore';

type Props = {
	sportello: EtichettaValore;
};

const ReferenceDesk = (props: Props) => {
	const [showDetails, setShowDetails] = useState(false);

	const onSOLClick = async () => {
		agent.Tracking.track(
			`${Static.onSOLClick} ${Static.fromReferenceDeskComponent}`,
			Static.urlVeritasSOL
		);

		window.open(Static.urlVeritasSOL, '_blank');
	};

	const viewOnGoogleMaps = async () => {
		agent.Tracking.track(
			`${Static.onViewOnGoogleMapsClick} ${Static.fromReferenceDeskComponent}`,
			Static.urlGoogleMaps + props.sportello.Valore
		);

		window.open(Static.urlGoogleMaps + props.sportello.Valore, '_blank');
	};

	const toggleDetails = async () => {
		agent.Tracking.track(
			`${Static.toggleDetail} ${Static.fromReferenceDeskComponent}`
		);
		setShowDetails((prev) => !prev);
	};
	return (
		<>
			<div className='card app-card-with-background ps-5 pe-5 pt-3 pb-3 mb-3 d-block d-sm-none'>
				<div className='app-toggle-show' onClick={toggleDetails}>
					<h4 className='mb-0'>SPORTELLO PIÙ VICINO</h4>
					<i
						className={showDetails ? 'fa fa-angle-up' : 'fa fa-angle-down'}
						style={{ fontSize: '1.5rem' }}
					></i>
				</div>
			</div>
			{showDetails && (
				<div className='card app-card-with-background p-5 d-block d-sm-none'>
					<div className='app-info-div'>
						<img
							alt=''
							className='app-info-icon'
							src='/images/veritas/invoice//MapsIcon.svg'
						/>
						<div className='ms-2'>
							<span> {props.sportello.Etichetta} </span>
							<br />
							<span className='app-bold'>{props.sportello.Valore}</span>
						</div>
					</div>
					<div className='app-info-div mt-4'>
						<img
							alt=''
							className='app-info-icon'
							src='/images/veritas/invoice//WorldIcon.svg'
						/>
						<div className='ms-2'>
							<span>SI ACCEDE ALLO SPORTELLO SOLO SU PRENOTAZIONE.</span>
							<br />
							<span>
								Puoi prenotare l’appuntamento sullo{' '}
								<span className='app-link' onClick={onSOLClick}>
									Sportello Online Veritas
								</span>
							</span>
						</div>
					</div>
					<button
						className='btn app-btn-details mt-4'
						onClick={viewOnGoogleMaps}
					>
						<img
							alt=''
							className='app-icon-white-hover'
							src='/images/veritas/invoice//OnGoogleMapsIcon.svg'
						/>
						Visualizza su Google Maps
					</button>
				</div>
			)}

			<div className='card app-card-with-background p-5 d-none d-sm-block'>
				<h4>SPORTELLO PIÙ VICINO</h4>
				<div className='app-info-div mt-4'>
					<img
						alt=''
						className='app-info-icon'
						src='/images/veritas/invoice//MapsIcon.svg'
					/>
					<div className='ms-2'>
						<span> {props.sportello.Etichetta} </span>
						<br />
						<span className='app-bold'>{props.sportello.Valore}</span>
					</div>
				</div>
				<div className='app-info-div mt-4'>
					<img
						alt=''
						className='app-info-icon'
						src='/images/veritas/invoice//WorldIcon.svg'
					/>
					<div className='ms-2'>
						<span>SI ACCEDE ALLO SPORTELLO SOLO SU PRENOTAZIONE.</span>
						<br />
						<span>
							Puoi prenotare l’appuntamento sullo{' '}
							<span className='app-link' onClick={onSOLClick}>
								Sportello Online Veritas
							</span>
						</span>
					</div>
				</div>
				<button className='btn app-btn-details mt-4' onClick={viewOnGoogleMaps}>
					<img
						alt=''
						className='app-icon-white-hover'
						src='/images/veritas/invoice//OnGoogleMapsIcon.svg'
					/>
					Visualizza su Google Maps
				</button>
			</div>
		</>
	);
};

export default ReferenceDesk;
